// App.tsx
import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

import "./theme/variables.css";
import "./theme/commons.css";

import Project from "./pages/Project";
import Movie from "./pages/Movie";
import Inicio from "./pages/Inicio";
import Schedules from "./pages/Schedules";
import Newsletter from "./pages/Newsletter";
import FullPageLoading from "./components/basic/full-page-loader";
import { I18nProvider } from "./i18n/i18n";
import Various from "./pages/Various";

setupIonicReact();

const App: React.FC = () => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShowLoader(false), 5200);
    return () => clearTimeout(t);
  }, []);

  if (showLoader) return <FullPageLoading />;

  return (
    <I18nProvider>
      <IonApp>
        <IonReactRouter>
          <IonRouterOutlet>
            <Route exact path="/inicio">
              <Inicio />
            </Route>
            <Route exact path="/project">
              <Project />
            </Route>
            <Route exact path="/movie">
              <Movie />
            </Route>
            <Route exact path="/schedule">
              <Schedules />
            </Route>
            <Route exact path="/newsletter">
              <Newsletter />
            </Route>
            <Route exact path="/various">
              <Various />
            </Route>
            <Route exact path="/">
              <Redirect to="/inicio" />
            </Route>
          </IonRouterOutlet>
        </IonReactRouter>
      </IonApp>
    </I18nProvider>
  );
};

export default App;
